export class NotePostCommand{
    verificationId: string;
    noteText: string;

    constructor(id:string, text:string){
        this.verificationId = id;
        this.noteText = text;
    }
}